import { render } from "./WelcomePage.vue?vue&type=template&id=33dc4650&scoped=true"
import script from "./WelcomePage.vue?vue&type=script&lang=js"
export * from "./WelcomePage.vue?vue&type=script&lang=js"

import "./WelcomePage.vue?vue&type=style&index=0&id=33dc4650&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dc4650"]])

export default __exports__